import { render, staticRenderFns } from "./BenefitsPage.vue?vue&type=template&id=04794f9d&scoped=true"
import script from "./BenefitsPage.vue?vue&type=script&lang=js"
export * from "./BenefitsPage.vue?vue&type=script&lang=js"
import style0 from "./BenefitsPage.vue?vue&type=style&index=0&id=04794f9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04794f9d",
  null
  
)

export default component.exports